import { tabTransformacaoApiStyle } from './TabTransformacaoApi.Style'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import TransformacaoApiManager from '../../../../services/api/transformacaoApi/transformacaoApiManager'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { RegraTransformacao } from '../../../../types/transformacaoApiTypes'
import { PAGES } from '../../../../router/routes'

export function tabTransformacaoApiIO() {
  const dispatch = useDispatch()
  const router = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()
  const [regrasList, setRegrasList] = useState<RegraTransformacao[]>([])
  const [modalAberto, setModalAberto] = useState(false)
  const [erroTransformacaoApi, setErroTransformacaoApi] = useState<string | null>(null)

  const buscarRegrasTransformacao = React.useCallback(async () => {
    dispatch(loadingUpdate(true))
    setErroTransformacaoApi(null)
    try {
      const response: RegraTransformacao[] = await TransformacaoApiManager.buscarRegras(parceiroId)
      setRegrasList(response)
    } catch (error: any) {
      setRegrasList([])
      setErroTransformacaoApi('Parceiro não habilitado para transformação api')
    }
    dispatch(loadingReset())
  }, [dispatch, parceiroId])

  const handleAdicionar = () => {
    router.push(PAGES.regraTransformacaoApiFormCadastro(parceiroId))
  }

  function fecharModal() {
    setModalAberto(false)
  }

  const handlePriorizar = () => {
    setModalAberto(true)
  }

  const getCampos = () => {
    return regrasList.map((item) => item.campo).filter((value, index, self) => self.indexOf(value) === index)
  }

  React.useEffect(() => {
    buscarRegrasTransformacao()
  }, [buscarRegrasTransformacao, dispatch, parceiroId])

  return {
    styles: tabTransformacaoApiStyle,
    handleAdicionar,
    regrasList,
    buscarRegrasTransformacao,
    modalAberto,
    fecharModal,
    handlePriorizar,
    getCampos,
    parceiroId,
    erroTransformacaoApi
  }
}

export type TabTransformacaoApiIO = ReturnType<typeof tabTransformacaoApiIO>
